<div class="bg-gradient-to-br from-slate-50 via-blue-50 to-purple-50 dark:from-slate-900 dark:via-blue-900/20 dark:to-purple-900/20">
  <particles [quantity]="120">
    <section class="pt-24 pb-12 px-6 lg:px-8 max-w-4xl mx-auto">
      <header class="mb-8">
        <h1 class="text-4xl font-light text-foreground">Terms &amp; Conditions</h1>
        <p class="text-sm text-muted-foreground mt-2">Last updated: {{ '2024-01-01' }}</p>
      </header>

      <div class="space-y-8 text-muted-foreground leading-relaxed">
        <section>
          <h2 class="text-xl font-semibold text-foreground mb-2">Acceptance of Terms</h2>
          <p>By using our services, you agree to these terms. If you don’t agree, do not use the service.</p>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-foreground mb-2">Use of Service</h2>
          <p>You must comply with applicable laws and avoid prohibited activities, including abuse or unauthorized access.</p>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-foreground mb-2">Subscriptions &amp; Billing</h2>
          <p>Plans auto‑renew unless canceled. Fees are non‑refundable unless required by law.</p>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-foreground mb-2">Limitation of Liability</h2>
          <p>We provide the service “as is.” Our liability is limited to the maximum extent permitted by law.</p>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-foreground mb-2">Contact</h2>
          <p>Legal inquiries: {{'legal@yourdomain.com'}}.</p>
        </section>
      </div>
    </section>
  </particles>
</div>
